import React from 'react';
import { Helmet } from 'react-helmet-async';
import LegalPageLayout from '@/components/legal/LegalPageLayout';
import { termsContent } from '@/content/legal/terms';

const TermsOfService: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Zentrix Insights</title>
        <meta name="description" content="Read the Terms of Service for using Zentrix Insights behavioral and cognitive assessment platform." />
        <meta property="og:title" content="Terms of Service | Zentrix Insights" />
        <meta property="og:description" content="Terms and conditions for using Zentrix Insights assessment services." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://zentrixinsights.com/terms" />
      </Helmet>
      <LegalPageLayout {...termsContent} />
    </>
  );
};

export default TermsOfService;
